export const logicalBiconditional = (p: boolean, q: boolean): boolean => (p && q) || !(p || q);

export const bicond = logicalBiconditional;
